import { Component, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { NGXLogger } from 'ngx-logger';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { DropdownModule } from 'primeng/dropdown';
import { StepsModule } from 'primeng/steps';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { InputNumberModule } from 'primeng/inputnumber';
import { MenuItem } from 'primeng/api';
import { SchedeService } from '../../../../services/schede.service';
import { InterventiService } from '../../../../services/interventi.service';
import { StiliService } from '../../../../services/stili.service';
import { Scheda } from '../../../../models/scheda.model';
import { TipoIntervento } from '../../../../models/tipo-intervento.model';
import { Intervento } from '../../../../models/intervento.model';
import { Richiesta } from '../../../../models/richiesta.model';
import { StatoRichiesta } from '../../../../models/stato-richiesta.model';

enum Step {
  SCHEDA = 0,
  DETTAGLI = 1
}

@Component({
  selector: 'app-aggiungi-intervento',
  templateUrl: './aggiungi-intervento.component.html',
  styleUrls: ['./aggiungi-intervento.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    DialogModule,
    ButtonModule,
    ToastModule,
    ReactiveFormsModule,
    DropdownModule,
    StepsModule,
    InputTextareaModule,
    InputNumberModule
  ],
  providers: [MessageService]
})
export class AggiungiInterventoComponent implements OnInit {
  @Output() interventoAggiunto = new EventEmitter<Intervento>();
  @Output() visibleChange = new EventEmitter<boolean>();
  @Input() richiesta!: Richiesta;
  protected readonly Step = Step;

  protected loadingSchede = true;

  visible = false;
  form!: FormGroup;
  activeIndex: Step = Step.SCHEDA;
  submitting = false;
  items: MenuItem[] = [
    {
      label: 'Scheda',
      icon: 'pi pi-fw pi-file'
    },
    {
      label: 'Dettagli',
      icon: 'pi pi-fw pi-pencil'
    }
  ];

  schede: Scheda[] = [];
  tipiIntervento: TipoIntervento[] = [];
  priorita = [
    { label: 'Alta', value: 1 },
    { label: 'Media', value: 2 },
    { label: 'Bassa', value: 3 },
  ];

  private fb = inject(FormBuilder);
  private schedaService = inject(SchedeService);
  private interventoService = inject(InterventiService);
  private messageService = inject(MessageService);
  public stiliService = inject(StiliService);

  constructor(
    private logger: NGXLogger
  ) {
    this.initForm();
  }

  ngOnInit(): void {
    this.initForm();
  }

  initForm() {
    this.form = this.fb.group({
      scheda: [{value: null, disabled: this.loadingSchede}, Validators.required],
      tipoIntervento: [null, Validators.required],
      priorita: [this.priorita[0], Validators.required],
      note: [''],
      importoFinanziato: [null]
    });
  }

  show() {
    this.visible = true;
    this.activeIndex = Step.SCHEDA;
    this.initForm();
    this.caricaSchede();
    this.caricaTipiIntervento();
  }

  hide() {
    this.visible = false;
    this.visibleChange.emit(false);
    this.form.reset();
  }

  caricaSchede(): void {
    this.loadingSchede = true;
    this.form.get('scheda')?.disable();

    this.schedaService.getSchede().subscribe({
      next: (data) => {
        this.schede = data;
        this.loadingSchede = false;
        this.form.get('scheda')?.enable();
      },
      error: (error) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Errore',
          detail: 'Errore nel caricamento delle schede'
        });
        this.loadingSchede = false;
        this.form.get('scheda')?.enable();
      }
    });
  }

  caricaTipiIntervento(): void {
    this.interventoService.getTipiIntervento().subscribe({
      next: (data) => {
        this.tipiIntervento = data;
        if (this.tipiIntervento && this.tipiIntervento.length > 0) {
          this.form.get('tipoIntervento')?.setValue(this.tipiIntervento.find(t => t.codice === 'MO'));
        }
      },
      error: (error) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Errore',
          detail: 'Errore nel caricamento dei tipi di intervento'
        });
      }
    });
  }

  nextStep() {
    if (this.activeIndex === 0 && !this.form.get('scheda')?.value) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Attenzione',
        detail: 'Seleziona una scheda prima di procedere'
      });
      return;
    }
    this.activeIndex++;
  }

  prevStep() {
    this.activeIndex--;
  }

  aggiungiIntervento() {
    if (this.form.invalid) {
      this.messageService.add({
        severity: 'error',
        summary: 'Errore',
        detail: 'Compila tutti i campi obbligatori'
      });
      return;
    }

    this.submitting = true;

    const formValue = this.form.value;
    const nuovoIntervento: Partial<Intervento> = {
      scheda: formValue.scheda,
      tipoIntervento: formValue.tipoIntervento,
      priorita: formValue.priorita.value,
      note: formValue.note,
      importoFinanziato: formValue.importoFinanziato,
      importoRimodulato: formValue.importoFinanziato,
      importoRichiesto: formValue.importoFinanziato
    };

    this.interventoAggiunto.emit(nuovoIntervento as Intervento);


    this.hide();
    this.submitting = false;
  }
}
